const { $ } = window
const $body = $(document.body)
import bigPicture from 'bigpicture'


export default {
   init() {},
   finalize() {
      if (document.getElementById('overview-show-more-link')) {
         let osml = document.getElementById('overview-show-more-link');
         //console.log($('#overview-part-two').css('display'));
         
         
         osml.addEventListener('click', function() {
            if ($('#overview-part-two').css('display') == 'block') {
               osml.innerHTML = osml.innerHTML.replace('Less', 'More');
               osml.querySelector('svg').style.transform = 'rotate(0deg)';
            } else {
               // do this
                osml.innerHTML = osml.innerHTML.replace('More', 'Less');
               osml.querySelector('svg').style.transform = 'rotate(180deg)';
            }
               $('#overview-part-two').slideToggle('500'); 
         });
      }

      if (document.getElementsByClassName('work-gallery') || document.getElementsByClassName('work-gallery-slider')) {
         let workimgs = document.querySelectorAll('.work-gallery img, .work-gallery-slider img:not(.slick-cloned)');

         console.log(workimgs);
         for (let i = 0; i < workimgs.length; i++) {
           workimgs[i].addEventListener('click', function() {
             bigPicture({
             // element from which animation starts (required)
               el: workimgs[i],
               // image url
               //imgSrc: 'https://yourimage.jpg',
               // video src (String) or sources (Array)
               //vidSrc: ['https://yourvideo.mp4', 'https://yourvideo.webm'],
               // iframe embed URL
               //iframeSrc: 'https://youriframe.html',
               // vimeo ID
               //vimeoSrc: '119287310',
               // youtube ID
               //ytSrc: 'z_PeaHVcohg',
               // use youtube-nocookie
               //ytNoCookie: false,
               // audio URL
               //audio: 'https://youraudio.mp3',
               // see below for more gallery options
               gallery: workimgs,
               // attribute used to find gallery elements
               galleryAttribute: 'src',
               // set custom dimensions for embeds / videos
               dimensions: [1920, 1080],
               // show or hide default loading indicator
               noLoader: false,
               // customize the overlay color (any valid css color value)
               overlayColor: 'rgba(0, 0, 0, .8)',
               // open animation callback
               animationStart: () => {},
               // open animation callback
               animationEnd: () => {},
               // close callback
               onClose: () => {},
               // gallery image change callback
               onChangeImage: () => {},
             })
           });
         }
      }

      $('.work-gallery-slider .inner-wrap-gallery').slick({
         dots: false,
         infinite: true,
         nextArrow: '.control-right',
         prevArrow: '.control-left'
      });

      if (document.getElementsByClassName('collaborator-team-member')) {
         let ctm = document.getElementsByClassName('collaborator-team-member');
         let i;

         for (i = 0; i < ctm.length; i++) {
            ctm[i].addEventListener('mouseenter', function() {
               let teamMemberId = this.getAttribute('id').replace('team-member-', '');
               
               document.getElementById('team-member-tooltip-' + teamMemberId).style.display = 'block';
            })
         }
         for (i = 0; i < ctm.length; i++) {
            ctm[i].addEventListener('mouseleave', function() {
               let teamMemberId = this.getAttribute('id').replace('team-member-', '');
               
               document.getElementById('team-member-tooltip-' + teamMemberId).style.display = 'none';
            })
         }
      }
   }
}